<svg display="none">
  <!-- add-button -->
  <symbol id="add-button" viewBox="0 0 20 19.496" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 9.749a9.887 9.887 0 0 1-10 9.747A9.887 9.887 0 0 1 0 9.749 9.888 9.888 0 0 1 10-.004a9.888 9.888 0 0 1 10 9.753zm-2.5 0A7.407 7.407 0 0 0 10 2.437a7.406 7.406 0 0 0-7.5 7.312 7.406 7.406 0 0 0 7.5 7.31 7.407 7.407 0 0 0 7.5-7.31zm-6.25-3.653v2.433h2.5a1.219 1.219 0 1 1 0 2.438h-2.5v2.437a1.25 1.25 0 0 1-2.5 0v-2.437h-2.5a1.219 1.219 0 1 1 0-2.438h2.5V6.096a1.25 1.25 0 0 1 2.5 0z"
      fill="#f04e29"
    ></path>
  </symbol>

  <!-- accessibility -->
  <symbol id="accessibility" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.99 32">
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path
          fill="#FFFFFF"
          d="M24.46,14.51A1.93,1.93,0,0,0,23,13.94l-6.63.37L20,10.15a2.19,2.19,0,0,0,.46-2.08,1.85,1.85,0,0,0-.84-1.21L10.91,1.8A1.88,1.88,0,0,0,8.69,2L4.43,5.81A1.9,1.9,0,0,0,7,8.65l3.23-2.87,2.66,1.54-4.7,5.36A9.72,9.72,0,0,0,3.06,15.2l2.46,2.45a6.25,6.25,0,0,1,8.83,8.83l2.45,2.46A9.71,9.71,0,0,0,18.46,18L21,17.86l-.62,7.65a1.89,1.89,0,0,0,1.74,2h.15a1.91,1.91,0,0,0,1.9-1.75L25,16A1.92,1.92,0,0,0,24.46,14.51Z"
        />
        <path fill="#FFFFFF" d="M20.93,6.36a3.18,3.18,0,1,0-3.18-3.18A3.18,3.18,0,0,0,20.93,6.36Z" />
        <path
          fill="#FFFFFF"
          d="M9.72,28.53a6.25,6.25,0,0,1-5.17-9.76L2.07,16.29A9.72,9.72,0,0,0,9.72,32a9.64,9.64,0,0,0,6-2.07l-2.48-2.48A6.23,6.23,0,0,1,9.72,28.53Z"
        />
      </g>
    </g>
  </symbol>
  <!--  <symbol id="accessibility" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.99 32">-->
  <!--    <g>-->
  <!--      <g>-->
  <!--        <circle cx="13" cy="3.5" r="3.5" fill="#FFFFFF"></circle>-->
  <!--        <path-->
  <!--          fill="#FFFFFF"-->
  <!--          d="M26,9.55A2.68,2.68,0,0,1,23.84,12l-5.49,2a2.33,2.33,0,0,0-1.1.67v0c-.07.12-.29.66,0,2.31l.36,1.82L19.93,29h0a2.38,2.38,0,0,1-.37,1.85A2.49,2.49,0,0,1,17.91,32a2.15,2.15,0,0,1-.43,0,2.56,2.56,0,0,1-2.43-1.93L13,23.73,11,30.06A2.57,2.57,0,0,1,8.1,32a2.57,2.57,0,0,1-1.68-1.12A2.39,2.39,0,0,1,6.08,29L8.41,18.8,8.77,17a5.85,5.85,0,0,0,0-2.44c-.08-.21-.24-.44-.85-.68L2.19,12h0C.47,11.42.05,10.39,0,9.61A2.41,2.41,0,0,1,.89,7.55a2.43,2.43,0,0,1,2.18-.46l.08,0A35.89,35.89,0,0,0,13,9a35,35,0,0,0,9.78-1.88l.07,0A2.38,2.38,0,0,1,25,7.47,2.59,2.59,0,0,1,26,9.55Z"-->
  <!--        ></path>-->
  <!--      </g>-->
  <!--    </g>-->
  <!--  </symbol>-->

  <!-- back-button -->
  <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8.843 15.914" id="back-button">
    <path
      d="M2.372 7.957l6.183-6.259a1 1 0 0 0 0-1.407.975.975 0 0 0-1.39 0L.287 7.254a1 1 0 0 0 0 1.406l6.878 6.962a.973.973 0 0 0 1.39 0 1 1 0 0 0 0-1.406z"
      fill="#fff"
    ></path>
  </symbol>

  <!-- checkbox-empty -->
  <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" id="checkbox-empty">
    <g fill="none" stroke="#665348">
      <rect width="20" height="20" rx="4" stroke="none"></rect>
      <rect x=".5" y=".5" width="19" height="19" rx="3.5"></rect>
    </g>
    <path
      d="M8.876 13.873a.633.633 0 0 1-.451-.188l-3.191-3.223a.649.649 0 0 1 0-.911.633.633 0 0 1 .9 0l2.668 2.7 5.3-7.136a.633.633 0 0 1 .892-.129.649.649 0 0 1 .128.9l-5.738 7.729a.633.633 0 0 1-.465.256z"
      fill="#fff"
    ></path>
  </symbol>

  <!-- checkbox-filled -->
  <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" id="checkbox-filled">
    <g fill="#f04e29" stroke="#665348">
      <rect width="20" height="20" rx="4" stroke="none"></rect>
      <rect x=".5" y=".5" width="19" height="19" rx="3.5" fill="none"></rect>
    </g>
    <path
      d="M8.876 13.873a.633.633 0 0 1-.451-.188l-3.191-3.223a.649.649 0 0 1 0-.911.633.633 0 0 1 .9 0l2.668 2.7 5.3-7.136a.633.633 0 0 1 .892-.129.649.649 0 0 1 .128.9l-5.738 7.729a.633.633 0 0 1-.465.256z"
      fill="#fff"
    ></path>
  </symbol>

  <!-- di-bafala -->
  <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36.909 27.586" id="di-bafala">
    <path
      d="M34.761 8.073l1.641 1.191-.3.406-1.96-1.408-.029.029a1.293 1.293 0 0 1-1 .465h-.087c-1.35 0-3.339-1.5-4.428-2.425l-.711 14.142-.116.087a2.636 2.636 0 0 1-2.817-.276c-.116-.116-.2-.189-.363-6.867l-1.931 1.757-1.779 11.546-.058.073a3.194 3.194 0 0 1-1.815.8h-.216a1.676 1.676 0 0 1-1.205-.9l-.014-.073v-.058l-.058-11.427-1.786.2-.363 8.857-.058.058a2.024 2.024 0 0 1-1.423.639 2.148 2.148 0 0 1-1.568-.813l-.058-.058-.029-.087-.421-5.662c-1.074 1.278-2.381 3.034-2.425 3.964a.547.547 0 0 0 .014.145.546.546 0 0 1 0 .479c-.16.3-.682.6-2.875 1.176a4.386 4.386 0 0 1-1 .145A1.991 1.991 0 0 1 4.1 23.67c-1.089-.973-.769-3.049-.769-3.136l1.321-6.432a6.8 6.8 0 0 1-4.254-3.005 2.955 2.955 0 0 1-.015-3.02l.2-.218.2.218a12.788 12.788 0 0 0 3.136 2.788 11.056 11.056 0 0 0 1.263.552l.276-1.278.029-.058c1.64-1.757 3.165-2.454 4.573-2.018.871-1.467 4.748-7.753 9.975-8.058h.407c2.846 0 5.6 1.858 8.145 5.532l.044.072v.1c.973.828 3.078 2.555 4.385 2.555h.058a1 1 0 0 0 .6-.232l-.13-1.975.508-.029.1 1.771 2.555-1.162.2.465z"
      fill="#fff"
    ></path>
    <path d="M7.379 21.567a.68.68 0 0 1-1.36 0 .681.681 0 0 1 1.36 0z" fill="#fff"></path>
    <path
      d="M6.695 20.931a.652.652 0 0 0-.675.639.681.681 0 0 0 1.362 0 .655.655 0 0 0-.687-.639zm0 .892a.263.263 0 0 1-.253-.253.241.241 0 0 1 .253-.217.245.245 0 0 1 .265.217.265.265 0 0 1-.265.253z"
      fill="#231f20"
    ></path>
    <path
      d="M10.058 15.204l-1.664-.2v.072h-.06a.945.945 0 0 0-.663.386.839.839 0 0 0-.181.687.95.95 0 0 0 .952.808.355.355 0 0 0 .157-.024.92.92 0 0 0 .675-.4 1.006 1.006 0 0 0 .181-.542c0-.048-.024-.084-.024-.133a.879.879 0 0 0-.109-.313l.687.084zm-1.121 1.085a.673.673 0 0 1-.41.241.6.6 0 0 1-.639-.458.481.481 0 0 1 .109-.362.549.549 0 0 1 .386-.217c.036 0 .06-.024.1-.024a.567.567 0 0 1 .554.458.5.5 0 0 1-.1.362z"
    ></path>
    <path
      d="M36.91 7.1l-.2-.465-2.555 1.162-.1-1.771-.508.029.13 1.975a1 1 0 0 1-.6.232h-.058c-1.307 0-3.412-1.728-4.385-2.555v-.1l-.044-.072C26.049 1.862 23.29.003 20.445.003h-.407c-5.227.305-9.1 6.592-9.975 8.058-1.408-.436-2.933.261-4.573 2.018l-.029.058-.276 1.278a11.056 11.056 0 0 1-1.263-.552A12.788 12.788 0 0 1 .786 8.075l-.2-.218-.2.218a2.955 2.955 0 0 0 .015 3.02A6.8 6.8 0 0 0 4.655 14.1l-1.321 6.432c0 .087-.32 2.163.769 3.136a1.991 1.991 0 0 0 1.423.508 4.386 4.386 0 0 0 1-.145c2.192-.581 2.715-.871 2.875-1.176a.546.546 0 0 0 0-.479.547.547 0 0 1-.014-.145c.044-.929 1.35-2.686 2.425-3.964l.421 5.662.029.087.058.058a2.148 2.148 0 0 0 1.568.813 2.024 2.024 0 0 0 1.423-.639l.058-.058.363-8.857 1.786-.2.058 11.427v.058l.014.073a1.676 1.676 0 0 0 1.205.9h.218a3.194 3.194 0 0 0 1.815-.8l.058-.073 1.771-11.543 1.931-1.757c.16 6.679.247 6.751.363 6.867a2.636 2.636 0 0 0 2.817.276l.116-.087.711-14.142c1.089.929 3.078 2.425 4.428 2.425h.087a1.293 1.293 0 0 0 1-.465l.029-.029 1.96 1.408.3-.406-1.641-1.191zM.845 10.889a2.89 2.89 0 0 1-.218-2.207 13.076 13.076 0 0 0 3.065 2.643 9.731 9.731 0 0 0 1.394.566L4.75 13.62c-1.219-.248-3.325-1.453-3.905-2.731zm11.383 6.127c-.116.145-.276.319-.465.537-1.045 1.176-2.831 3.4-2.889 4.632a.783.783 0 0 0 .044.348.478.478 0 0 1 .043.087c-.043.1-.45.363-2.555.9a2.025 2.025 0 0 1-1.96-.218c-.886-.813-.61-2.686-.61-2.686l1.321-6.432.1-.552.334-1.641.087-.465.247-1.147c1.524-1.64 2.933-2.25 4.138-1.8a3.777 3.777 0 0 1 1.728 1.481 8.06 8.06 0 0 1-1.786.6l-.291.087-.058.1a2.174 2.174 0 0 0 .406 2.628 1.026 1.026 0 0 0 .7.2 3.525 3.525 0 0 0 .784-.116 5.57 5.57 0 0 0 1.248-.537c-.073.958-.261 2.715-.378 3.79-.043.045-.101.117-.188.208zm-.174-6.534c.073-.043.131-.058.218-.116.087-.029.145-.073.218-.1.348-.2.711-.436 1.176-.711 1.64-1.016 2.773-4.051 3.18-5.227a4.494 4.494 0 0 1 .2 3.644c-.45 1.539-2.163 3.151-3.761 4.167-.087.044-.145.1-.232.145a1.428 1.428 0 0 0-.218.145 7.844 7.844 0 0 1-1.437.639 1.345 1.345 0 0 1-1.016.029 1.693 1.693 0 0 1-.32-1.931l.058-.015a7.639 7.639 0 0 0 1.933-.668zm16.073-4.559l-.741 14.243a2.036 2.036 0 0 1-2.047-.218c-.087-.624-.2-4.617-.247-7.1l-.015-.552-2.831 2.555-.087.058-1.757 11.572a2.468 2.468 0 0 1-1.539.61 1.072 1.072 0 0 1-.784-.61l-.058-11.63v-.291l-2.773.334-.392 9.075a1.564 1.564 0 0 1-.973.406 1.6 1.6 0 0 1-1.147-.6l-.465-6.054c.218-.247.406-.465.566-.639l.058-.058.029-.073c0-.145.334-3.194.392-4.225 1.742-1.06 3.688-2.846 4.211-4.617.886-3.034-.537-4.457-.61-4.486l-.3-.29-.116.392c0 .029-1.278 4.269-3.093 5.4q-.7.436-1.176.7a4.225 4.225 0 0 0-1.67-1.568c.842-1.466 4.661-7.463 9.525-7.753h.334c2.613 0 5.14 1.655 7.506 4.951.058.087.145.189.2.29z"
    ></path>
  </symbol>

  <!-- dropdown -->
  <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.628 22.628" id="dropdown">
    <path
      d="M12.021 21.92a1.018 1.018 0 0 1-.324.218c-.007.007-.02.004-.029.008a.971.971 0 0 1-.312.06.912.912 0 0 1-.103-.005.968.968 0 0 1-.248-.048c-.034-.011-.065-.021-.099-.035a1.01 1.01 0 0 1-.299-.198L7.78 19.092a1 1 0 0 1 1.414-1.414l1.122 1.122v-4.657a1 1 0 0 1 2 0v4.656l1.12-1.121a1 1 0 1 1 1.415 1.414zm-.707-12.435a1 1 0 0 1-1-1V3.828L9.193 4.95a1 1 0 1 1-1.414-1.414L10.607.707c.009-.008.02-.011.03-.02a.965.965 0 0 1 .295-.197c.007-.007.02-.003.03-.007a.963.963 0 0 1 .311-.061c.036-.002.068.002.103.005a1 1 0 0 1 .246.049.857.857 0 0 1 .103.038.985.985 0 0 1 .296.193l2.829 2.829a1 1 0 0 1-1.414 1.414l-1.122-1.122v4.657a1 1 0 0 1-1 1z"
      fill="#665348"
    ></path>
  </symbol>

  <!-- existing-card -->
  <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 12" id="existing-card">
    <path
      d="M2 12a2.006 2.006 0 0 1-2-2V2a2.006 2.006 0 0 1 2-2h12a2.006 2.006 0 0 1 2 2v8a2.006 2.006 0 0 1-2 2zm0-2h12V6H2zm0-6h12V2H2zm4 5H5a1 1 0 1 1 0-2h2a1 1 0 0 1 0 2z"
      fill="#665348"
    ></path>
  </symbol>

  <!-- find-location -->
  <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" id="find-location">
    <circle cx="3.659" cy="3.659" r="3.659" transform="translate(6.342 6.342)" fill="#665348"></circle>
    <path
      d="M17.932 8.627a8.054 8.054 0 0 0-6.558-6.559.475.475 0 0 1-.4-.468V.764A.764.764 0 0 0 10.21 0h-.423a.764.764 0 0 0-.764.764V1.6a.475.475 0 0 1-.4.468 8.056 8.056 0 0 0-6.559 6.559.475.475 0 0 1-.467.4H.761a.765.765 0 0 0-.765.764v.422a.765.765 0 0 0 .765.765h.836a.474.474 0 0 1 .467.4 8.054 8.054 0 0 0 6.559 6.558.475.475 0 0 1 .4.468v.837a.764.764 0 0 0 .764.764h.423a.764.764 0 0 0 .764-.764V18.4a.475.475 0 0 1 .4-.468 8.051 8.051 0 0 0 6.558-6.558.476.476 0 0 1 .468-.4h.836a.764.764 0 0 0 .764-.765v-.422a.764.764 0 0 0-.764-.764H18.4a.477.477 0 0 1-.468-.396zm-7.375 7.446a6.1 6.1 0 1 1 5.516-5.516 6.1 6.1 0 0 1-5.516 5.516z"
      fill="#665348"
      fill-rule="evenodd"
    ></path>
  </symbol>

  <!-- information -->
  <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" id="information">
    <circle cx="13" cy="13" r="13" fill="rgba(0,0,0,0)"></circle>
    <path
      d="M3.001 13a10 10 0 1 1 10 10 10.011 10.011 0 0 1-10-10zm2.5 0a7.5 7.5 0 1 0 7.5-7.5 7.5 7.5 0 0 0-7.5 7.5zm7.144 5a.894.894 0 0 1-.894-.895v-3.21a.9.9 0 0 1 .894-.895h.711a.894.894 0 0 1 .894.895v3.211a.894.894 0 0 1-.894.895zm-.894-8.749a1.25 1.25 0 1 1 1.25 1.249 1.25 1.25 0 0 1-1.25-1.249z"
      fill="#f04e29"
    ></path>
  </symbol>

  <!-- location -->
  <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 16" id="location">
    <path
      d="M6.257 15.857C6 15.754 0 13.282 0 7a7 7 0 1 1 14 0c0 6.282-6 8.754-6.257 8.857a2 2 0 0 1-1.486 0zM2 7c0 5 5 7 5 7s5-2 5-7A5 5 0 1 0 2 7zm2 0a3 3 0 1 1 3 3 3 3 0 0 1-3-3zm2 0a1 1 0 1 0 1-1 1 1 0 0 0-1 1z"
      fill="#665348"
    ></path>
  </symbol>

  <!-- map-location -->
  <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29.312 33.5" id="map-location">
    <path
      d="M14.655 31.631l6.466-2.932 3.719-6.2 2.453-7.589-1.3-6.819-6.72-5.508-8.069-.436-6.068 3.644-3.489 7.313 1.517 7.148 4.92 8.163z"
      fill="#fff"
    ></path>
    <path
      d="M13.1 33.199C12.567 32.985 0 27.808 0 14.656a14.656 14.656 0 1 1 29.311 0c0 13.153-12.567 18.329-13.1 18.544a4.188 4.188 0 0 1-3.111 0zM4.187 14.656c0 10.468 10.47 14.655 10.47 14.655s10.468-4.187 10.468-14.655a10.469 10.469 0 1 0-20.937 0zm4.187 0a6.282 6.282 0 1 1 6.282 6.281 6.29 6.29 0 0 1-6.282-6.281zm4.187 0a2.094 2.094 0 1 0 2.1-2.094 2.1 2.1 0 0 0-2.1 2.094z"
      fill="#f05523"
    ></path>
  </symbol>

  <!-- menu-bag -->
  <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.994 17.597" id="menu-bag">
    <path
      d="M14.444 4.861h-2.287v-1.2a3.665 3.665 0 1 0-7.33 0v1.2H2.544L0 17.594h16.995zm-8.455-1.2a2.507 2.507 0 1 1 5.015 0v1.2H5.989zM3.497 6.014h1.335v1.718a.579.579 0 0 0 1.158 0V6.014h5.015v1.718a.579.579 0 0 0 1.158 0V6.014h1.335l2.086 10.421H1.414z"
      fill="#665348"
    ></path>
  </symbol>

  <!-- new-card -->
  <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 14" id="new-card">
    <path
      d="M12 13v-1h-1a1 1 0 0 1 0-2h1V9a1 1 0 0 1 2 0v1h1a1 1 0 0 1 .91.59A1.866 1.866 0 0 0 16 10v1a1 1 0 0 1-1 1h-1v1a1 1 0 1 1-2 0zM2 12a2.006 2.006 0 0 1-2-2V2a2.006 2.006 0 0 1 2-2h12a2.006 2.006 0 0 1 2 2v4H2v4h5a1 1 0 0 1 0 2zm0-8h12V2H2zm4 5H5a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2z"
      fill="#665348"
    ></path>
  </symbol>

  <!-- pill-container-x -->
  <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7.771 7.771" id="pill-container-x">
    <path
      d="M7.475 6.04L5.321 3.886l2.154-2.154A1.015 1.015 0 0 0 6.039.296L3.885 2.45 1.732.296A1.015 1.015 0 0 0 .296 1.732l2.153 2.154L.296 6.04a1.015 1.015 0 0 0 1.436 1.436l2.153-2.154 2.154 2.154A1.015 1.015 0 0 0 7.475 6.04z"
      fill="#665348"
    ></path>
  </symbol>

  <!-- popup-x -->
  <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.828 15.913" id="popup-x">
    <path
      d="M9.313 7.957l6.225-6.259a1 1 0 0 0 0-1.407.986.986 0 0 0-1.4 0L7.913 6.55 1.688.291a.986.986 0 0 0-1.4 0 1 1 0 0 0 0 1.407l6.225 6.259-6.225 6.259a1 1 0 0 0 0 1.406.986.986 0 0 0 1.4 0l6.225-6.259 6.225 6.259a.992.992 0 0 0 1.4-1.406z"
      fill="#665348"
    ></path>
  </symbol>

  <!-- radio-button-empty -->
  <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" id="radio-button-empty">
    <g fill="#fff" stroke="#665348">
      <circle cx="10" cy="10" r="10" stroke="none"></circle>
      <circle cx="10" cy="10" r="9.5" fill="none"></circle>
    </g>
  </symbol>

  <!-- radio-button-filled -->
  <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" id="radio-button-filled">
    <g transform="translate(-989 -486)">
      <g transform="translate(989 486)" fill="#fff" stroke="#665348">
        <circle cx="10" cy="10" r="10" stroke="none"></circle>
        <circle cx="10" cy="10" r="9.5" fill="none"></circle>
      </g>
      <circle cx="7" cy="7" r="7" transform="translate(992 489)" fill="#f04e29"></circle>
    </g>
  </symbol>

  <!-- subtract-button -->
  <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 19.496" id="subtract-button">
    <path
      d="M20 9.749a9.887 9.887 0 0 1-10 9.747A9.887 9.887 0 0 1 0 9.749 9.888 9.888 0 0 1 10-.004a9.888 9.888 0 0 1 10 9.753zm-2.5 0A7.406 7.406 0 0 0 10 2.437a7.406 7.406 0 0 0-7.5 7.312 7.406 7.406 0 0 0 7.5 7.31 7.406 7.406 0 0 0 7.5-7.31zm-3.75-1.22a1.219 1.219 0 1 1 0 2.438h-7.5a1.219 1.219 0 1 1 0-2.438z"
      fill="#f04e29"
    ></path>
  </symbol>

  <!-- LOGO -->
  <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 180 70" id="logo-svg">
    <path
      d="M180 45.613l-.173-26.588a4.417 4.417 0 0 0-3.852-4.1c-21.486-3.57-78.7-13.228-84.924-14.667l-.915-.217-.139-.033-1.04.25c-6.2 1.417-63.431 11.082-84.934 14.667v.008a4.372 4.372 0 0 0-3.856 4.09L0 45.588a4.438 4.438 0 0 0 3.6 4.163l86.395 20.255 1.084-.248 85.342-20.013-.006-.014A4.424 4.424 0 0 0 180 45.613z"
      fill="#f04e29"
    ></path>
    <path
      d="M20.559 23.494v.807c3.105.027 3.265 1.165 3.238 3.533l-.087 14.864a2.3 2.3 0 0 0 2.477 2.284h.959c0-.737.042-7.607.042-7.607.268-1.9 1.923-1.969 4.022-2.068l1.244-.065c3.762-.274 5.753-2.313 5.786-5.875.01-3.611-2.65-5.872-6.953-5.872H20.559zm6.664 8.471l.044-7.062h2.123c3.742 0 5.566 1.544 5.537 4.718-.008 3.1-1.585 4.37-5.405 4.37-1.744 0-2.299-.503-2.299-2.026zm38.75-4.483l-.029 10.267c-.235 3.329-1.572 5.022-3.977 5.022-2.656 0-3.552-1.433-3.544-5.618l.039-10.767h-6.435v1.56h.422c2.1 0 2.188.531 2.173 2.548l-.029 7.976c0 4.334 2.278 6.367 7.175 6.367 5.216 0 7.146-1.991 7.151-7.391l.027-9.963a1.413 1.413 0 0 0-1.47-1.329 1.427 1.427 0 0 0-1.503 1.328zm14.124-.948v1.421h.346c2.069 0 2.273.433 2.273 2.185v13.421a1.251 1.251 0 0 0 1.323 1.241 1.334 1.334 0 0 0 1.383-1.186V31.095c.593.99 6.639 11.434 6.639 11.434.757 1.335 2.521 1.992 5.339 1.992h.346l-.017-18.14h-3.363v13.7h-.05c-.073-.172-7.912-13.69-7.912-13.69l-6.31-.015zm31.203 8.892c.025 6.807 2.647 9.724 8.756 9.724 3.875 0 5.886-1.105 5.878-2.177a.979.979 0 0 0-.977-.956 4.355 4.355 0 0 0-1.552.535 7.979 7.979 0 0 1-2.849.533c-3.569 0-5.231-2.414-5.239-7.658-.016-4.828 1.273-6.971 4.2-6.971 2.38 0 3.733.88 3.9 2.564l.019.127h1.687l-.015-3.771-.087-.029a14.2 14.2 0 0 0-5.17-.913c-5.839-.002-8.551 2.847-8.551 8.992zm25.136-11.914v.771h.025c3.011 0 3.182.888 3.188 3.4l.073 15.639a1.626 1.626 0 0 0 1.745 1.656 1.673 1.673 0 0 0 1.714-1.709l-.019-6.357a2.616 2.616 0 0 1 2.816-2.493h7.067s.066 9.8.075 10.559h3.444c0-.78-.135-20.7-.135-21.469h-3.44c0 .717.046 7 .046 7a2.811 2.811 0 0 1-2.957 2.533h-6.952s-.05-8.827-.05-9.553c-.749.013-5.909.023-6.64.023z"
      fill="#fff"
    ></path>
    <path
      d="M89.868 66.61c-.6-.135-82.751-19.41-85.286-20.005h-.038a1.066 1.066 0 0 1-.892-1.006l.179-26.555a.922.922 0 0 1 .691-.861l.122-.062h.1c3.769-.627 77.707-13.007 85.117-14.725l.131-.033.129.033c7.427 1.717 81.355 14.1 85.134 14.725h.145l.106.074a.912.912 0 0 1 .653.849l.175 26.573a1.057 1.057 0 0 1-.882.988h-.043c-2.558.6-84.689 19.87-85.288 20.005l-.129.036-.129-.036zm-42.632-11.2l42.765 10.03 42.761-10.03c20.721-4.859 41.367-9.706 42.407-9.948l-.17-26.2c-4.522-.759-76.811-12.858-85-14.7-8.186 1.845-80.579 13.962-84.994 14.7l-.183 26.2c.917.219 21.607 5.076 42.417 9.953zM4.79 19.047v-.005h-.373l.373.005z"
      fill="#fff"
    ></path>
  </symbol>

  <!-- CheckMArk -->
  <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10.2 9.018" id="checkmarkIcon">
    <path
      d="M3.824 9.018a.633.633 0 0 1-.451-.188L.182 5.607a.649.649 0 0 1 0-.911.633.633 0 0 1 .9 0l2.668 2.7L9.05.26a.633.633 0 0 1 .892-.129.649.649 0 0 1 .128.9L4.332 8.76a.633.633 0 0 1-.465.256z"
      fill="#fff"
    ></path>
  </symbol>

  <!-- search Icon -->
  <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.914 16" id="searchIcon">
    <path
      d="M15.623 14.293l-4.8-4.822A5.956 5.956 0 1 0 5.968 12a5.905 5.905 0 0 0 3.452-1.115l4.8 4.822a.991.991 0 0 0 1.407 0 1 1 0 0 0-.004-1.414zM5.968 10a4 4 0 1 1 3.978-4 3.989 3.989 0 0 1-3.978 4z"
      fill="#665348"
    ></path>
  </symbol>

  <!-- hamburger-icon -->
  <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.479 12.306" id="ham-icon">
    <path fill="#665348" d="M0 0h19.479v1.5H0zm0 5.402h19.479v1.5H0zm0 5.404h19.479v1.5H0z"></path>
  </symbol>

  <!-- OR -->
  <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 299 23" id="orGroup">
    <text
      transform="translate(149 17)"
      fill="#333"
      font-size="16"
      font-family="BrandonGrotesque-Bold, Brandon Grotesque"
      font-weight="700"
    >
      <tspan x="-11.728" y="0">OR</tspan>
    </text>
    <path fill="none" stroke="#aca095" d="M0 11.5h126m47 0h126"></path>
  </symbol>

  <!--More Info-->
  <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 674 33" id="orderDetailsIcon">
    <path fill="none" stroke="#aca095" d="M437 16.5h237m-674 0h237"></path>
    <text
      transform="translate(332.5 24)"
      fill="#333"
      font-size="23"
      font-family="BrandonGrotesque-Bold, Brandon Grotesque"
      font-weight="700"
    >
      <tspan x="-64.377" y="0">MORE INFO</tspan>
    </text>
  </symbol>

  <!-- Forward Button -->
  <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8.843 15.914" id="forwardArrow">
    <path
      d="M6.471 7.957L.288 14.216a1 1 0 0 0 0 1.407.975.975 0 0 0 1.39 0L8.556 8.66a1 1 0 0 0 0-1.406L1.678.292a.973.973 0 0 0-1.39 0 1 1 0 0 0 0 1.406z"
      fill="#333"
    ></path>
  </symbol>

  <!-- MapIcon -->
  <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29.311 33.5" id="mapIcon">
    <path
      d="M14.655 31.632l6.466-2.932 3.719-6.2 2.453-7.589-1.3-6.819-6.72-5.508-8.069-.436-6.068 3.644-3.489 7.313 1.517 7.148 4.92 8.163z"
      fill="#fff"
    ></path>
    <path
      d="M13.1 33.2C12.567 32.986 0 27.809 0 14.657a14.656 14.656 0 1 1 29.311 0c0 13.153-12.567 18.329-13.1 18.544a4.188 4.188 0 0 1-3.111 0zM4.187 14.657c0 10.468 10.47 14.655 10.47 14.655s10.468-4.187 10.468-14.655a10.469 10.469 0 1 0-20.937 0zm4.187 0a6.282 6.282 0 1 1 6.282 6.281 6.29 6.29 0 0 1-6.282-6.281zm4.187 0a2.094 2.094 0 1 0 2.1-2.094 2.1 2.1 0 0 0-2.1 2.094z"
      fill="#f05523"
    ></path>
  </symbol>

  <!--INDIVIDUAL LOCATIONS LINES-->
  <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 674 1" id="locationLines">
    <path d="M437 .5h237M0 .5h237" fill="none" stroke="#aca095"></path>
  </symbol>

  <!--Return TO Punch-->
  <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 76 79" id="returnToPunchBanner">
    <path opacity=".5" fill="#efeade" d="M76 0v79l-38-5.5L0 79V0z"></path>
    <path
      d="M76 75.9v1.01l-38.5-5.9L0 76.92V75.9l37.5-5.91zM14.41 28.51c0-.12.1-.23.23-.23h3.43c1.44 0 2.61 1.15 2.61 2.58 0 1.1-.73 2-1.77 2.42l1.64 3.05c.08.16 0 .35-.2.35h-1.26c-.11 0-.17-.06-.19-.11l-1.6-3.18h-1.33v3.06c0 .12-.11.23-.23.23h-1.1c-.13 0-.23-.11-.23-.23v-7.94zm3.53 3.6c.64 0 1.19-.55 1.19-1.22 0-.64-.55-1.16-1.19-1.16h-1.96v2.39h1.96v-.01zm4.95-3.6c0-.12.1-.23.23-.23H28c.13 0 .23.11.23.23v.98c0 .12-.1.23-.23.23h-3.55v1.97h2.96c.12 0 .23.11.23.23v1c0 .13-.11.23-.23.23h-2.96v2.1H28c.13 0 .23.11.23.23v.98c0 .12-.1.23-.23.23h-4.88c-.13 0-.23-.11-.23-.23v-7.95zm8.66 1.21h-1.83c-.13 0-.23-.11-.23-.23v-.98c0-.12.1-.23.23-.23h5.24c.13 0 .23.11.23.23v.98c0 .12-.1.23-.23.23h-1.83v6.73c0 .12-.11.23-.23.23h-1.12a.24.24 0 0 1-.23-.23v-6.73zm5.24-1.21c0-.12.11-.23.23-.23h1.14c.13 0 .23.11.23.23v4.91c0 1.02.7 1.82 1.74 1.82s1.75-.8 1.75-1.81v-4.92c0-.12.1-.23.23-.23h1.14c.12 0 .23.11.23.23v4.99c0 1.82-1.45 3.3-3.35 3.3-1.88 0-3.33-1.48-3.33-3.3v-4.99h-.01zm9.23 0c0-.12.1-.23.23-.23h3.43c1.44 0 2.61 1.15 2.61 2.58 0 1.1-.73 2-1.77 2.42l1.64 3.05c.08.16 0 .35-.2.35H50.7c-.11 0-.17-.06-.19-.11l-1.6-3.18h-1.33v3.06c0 .12-.11.23-.23.23h-1.1c-.13 0-.23-.11-.23-.23v-7.94zm3.53 3.6c.64 0 1.19-.55 1.19-1.22 0-.64-.55-1.16-1.19-1.16h-1.96v2.39h1.96v-.01zm4.94-3.73c0-.12.11-.22.23-.22h.3l4.99 5.3h.01v-4.95c0-.12.1-.23.23-.23h1.1c.12 0 .23.11.23.23v8.07c0 .12-.11.22-.23.22h-.29l-5.01-5.51h-.01v5.16c0 .12-.1.23-.23.23h-1.09a.24.24 0 0 1-.23-.23v-8.07zM8.23 44.12H6.4c-.13 0-.23-.11-.23-.23v-.98c0-.12.1-.23.23-.23h5.24c.13 0 .23.11.23.23v.98c0 .12-.1.23-.23.23H9.81v6.73c0 .12-.11.23-.23.23H8.46a.24.24 0 0 1-.23-.23v-6.73zm8.98-1.56c2.4 0 4.32 1.93 4.32 4.33s-1.92 4.3-4.32 4.3-4.31-1.91-4.31-4.3c.01-2.4 1.92-4.33 4.31-4.33zm0 7.08c1.51 0 2.76-1.24 2.76-2.75s-1.25-2.77-2.76-2.77-2.75 1.26-2.75 2.77c.01 1.51 1.24 2.75 2.75 2.75zm9.51-6.73c0-.12.1-.23.23-.23h2.82c1.48 0 2.69 1.2 2.69 2.65 0 1.49-1.21 2.7-2.67 2.7h-1.5v2.82c0 .12-.11.23-.23.23h-1.1c-.13 0-.23-.11-.23-.23l-.01-7.94zm2.95 3.66c.67 0 1.24-.54 1.24-1.25 0-.66-.56-1.16-1.24-1.16h-1.39v2.41h1.39zm4.51-3.66c0-.12.11-.23.23-.23h1.14c.13 0 .23.11.23.23v4.91c0 1.02.7 1.82 1.74 1.82s1.75-.8 1.75-1.81v-4.92c0-.12.1-.23.23-.23h1.14c.12 0 .23.11.23.23v4.99c0 1.82-1.45 3.3-3.35 3.3-1.88 0-3.33-1.47-3.33-3.3v-4.99h-.01zm9.23-.13c0-.12.11-.22.23-.22h.3l4.99 5.3h.01v-4.95c0-.12.1-.23.23-.23h1.1c.12 0 .23.11.23.23v8.07c0 .12-.11.22-.23.22h-.29l-5.01-5.5h-.01v5.16c0 .12-.1.23-.23.23h-1.09a.24.24 0 0 1-.23-.23v-8.08zm13.47-.22c1.21 0 2.09.38 2.9 1.12.11.1.11.24.01.34l-.73.76c-.08.1-.2.1-.3 0-.5-.44-1.17-.71-1.85-.71-1.54 0-2.67 1.28-2.67 2.79 0 1.5 1.15 2.77 2.69 2.77.72 0 1.33-.28 1.83-.68.1-.08.23-.07.3 0l.74.77c.1.08.07.24-.01.32a4.13 4.13 0 0 1-2.91 1.16c-2.4 0-4.33-1.91-4.33-4.3.01-2.41 1.94-4.34 4.33-4.34zm4.97.35c0-.12.11-.23.23-.23h1.12c.13 0 .23.11.23.23v3.18h3.91v-3.18c0-.12.1-.23.23-.23h1.1c.12 0 .23.11.23.23v7.94c0 .12-.11.23-.23.23h-1.1c-.13 0-.23-.11-.23-.23v-3.31h-3.91v3.31c0 .12-.1.23-.23.23h-1.12a.24.24 0 0 1-.23-.23v-7.94z"
    ></path>
  </symbol>

  <!-- edit icon -->
  <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" id="editIcon">
    <title>ionicons-v5-n</title>
    <path
      d="M384 224v184a40 40 0 0 1-40 40H104a40 40 0 0 1-40-40V168a40 40 0 0 1 40-40h167.48"
      fill="none"
      stroke="#000"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="32"
    ></path>
    <path
      d="M459.94 53.25a16.06 16.06 0 0 0-23.22-.56L424.35 65a8 8 0 0 0 0 11.31l11.34 11.32a8 8 0 0 0 11.34 0l12.06-12c6.1-6.09 6.67-16.01.85-22.38zM399.34 90L218.82 270.2a9 9 0 0 0-2.31 3.93L208.16 299a3.91 3.91 0 0 0 4.86 4.86l24.85-8.35a9 9 0 0 0 3.93-2.31L422 112.66a9 9 0 0 0 0-12.66l-9.95-10a9 9 0 0 0-12.71 0z"
    ></path>
  </symbol>
</svg>

<svg [ngClass]="svgID + (big ? ' big-icon' : '')">
  <use *ngIf="svgID" attr.xlink:href="#{{ svgID }}"></use>
</svg>
